import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=ac670a8e&"
import script from "./ContactUs.ts?vue&type=script&lang=ts&"
export * from "./ContactUs.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports